import {SuccessfulApiResponse} from "@eryxcoop/appyx-comm";

export default class DeliveryZoneResponse extends SuccessfulApiResponse {
    static defaultResponse() {
        return {
            object: {
                zone: 'CABA',
                frequency: 'MARTES, JUEVES, SÁBADO',
                out_of_zone: false,
            },
            errors: [],
        };
    }

    zone() {
        return this.content().zone;
    }

    frequency() {
        return this.content().frequency;
    }

    isOutOfZone() {
        return this.content().out_of_zone;
    }
}
